import React from 'react';
import '../layout/TopBar.css';
import './HistoryPanel.css';
import { sendMessageToApp } from '../../utils/nativeBridge';

const GROUPS = [
  { key: 'today', label: 'Today' },
  { key: 'thisWeek', label: 'This Week' },
  { key: 'earlier', label: 'Earlier' },
];

/**
 * 历史会话弹窗（底部弹起的白色圆角卡片，上方露出暗色遮罩，点遮罩关闭）。
 * - hasBack：是否显示左上角 Back（点击返回对话页）。
 * - closeExitsApp：右上角 × 的行为。true=关闭整个 webview(native Close)；false=仅关闭历史页返回对话。
 * - onSelect(id)：点击某条会话。
 */
const HistoryPanel = ({ show, groups, loading, hasBack, closeExitsApp, onBack, onClose, onSelect }) => {
  if (!show) return null;

  const handleClose = () => {
    if (closeExitsApp) {
      sendMessageToApp('Close');
    } else if (onClose) {
      onClose();
    }
  };

  const data = groups || {};
  const hasAny = GROUPS.some((g) => Array.isArray(data[g.key]) && data[g.key].length > 0);

  return (
    <div className="history-overlay" onClick={() => onClose && onClose()}>
      <div className="history-panel" onClick={(e) => e.stopPropagation()}>
      <div className="top-button-container">
        <div className="history-topbar-left">
          {hasBack && (
            <button className="button-top button-back" onClick={() => onBack && onBack()}>
              <span className="icon">
                <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.11364 0.75L0.75 7.75M0.75 7.75L8.11364 14.75M0.75 7.75H18.75" stroke="#191919" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
              Back
            </button>
          )}
        </div>

        <div className="top-button-right-group">
          <button className="button-top" onClick={handleClose}>
            <span className="icon">
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.002 18.001L29.9994 29.9984" stroke="#191919" stroke-width="1.5" stroke-linecap="round"/>
                <path d="M29.998 18.001L18.0006 29.9984" stroke="#191919" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </span>
          </button>
        </div>
      </div>

      <div className="history-content">
        <h1 className="history-title">History</h1>

        {loading && <div className="history-empty">Loading...</div>}

        {!loading && !hasAny && <div className="history-empty">No conversations yet.</div>}

        {!loading && hasAny && GROUPS.map((g) => {
          const list = Array.isArray(data[g.key]) ? data[g.key] : [];
          if (list.length === 0) return null;
          return (
            <div className="history-group" key={g.key}>
              <div className="history-group-label">{g.label}</div>
              {list.map((item) => (
                <button
                  className="history-item"
                  key={item.id}
                  onClick={() => onSelect && onSelect(item.id)}
                >
                  <span className="history-item-text">{item.subject}</span>
                </button>
              ))}
            </div>
          );
        })}
      </div>
      </div>
    </div>
  );
};

export default HistoryPanel;
